export default __webpack_public_path__ + "static/flyer-vivawest-919ca30239fe61f8b4e7cc5d5c84d7fc.jpg";